import React from 'react';
import { Refresh } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import Logo from '../assets/images/logo/starcard_club_white.png';
import AppButton from './ui/AppButton';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            width: '100%',
            height: '100vh',
            backgroundColor: '#E1000C',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            px: 2,
          }}
        >
          <Box
            component={'img'}
            src={Logo}
            alt="Caltex Starcard Club Logo"
            sx={{ width: '100%', maxWidth: 220 }}
          />
          <Typography
            component="h1"
            sx={{
              fontSize: '4rem',
              fontWeight: 700,
              lineHeight: 1,
              color: 'white',
              textAlign: 'center',
              mt: 2,
            }}
          >
            Oops!
          </Typography>
          <Typography
            component="h2"
            sx={(theme) => ({
              fontSize: '1.5rem',
              lineHeight: 1,
              fontWeight: '500',
              color: 'white',
              marginTop: '15px',
              marginBottom: '25px',
              textAlign: 'center',

              [theme.breakpoints.up('sm')]: {
                fontSize: '2.5rem',
              },
            })}
          >
            Something went wrong.
          </Typography>
          <Typography
            sx={{
              fontSize: {
                xs: '1.125rem',
                sm: '1.25rem',
              },
              lineHeight: 1.5,
              fontWeight: '300',
              color: '#fafafa',
              mb: 6,
              textAlign: 'center',
            }}
          >
            An unexpected error occurred. <br />
            Please try again or return to the homepage.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: '15px',
              alignItems: 'center',
              flexDirection: {
                xs: 'column-reverse',
                sm: 'row',
              },
              width: '100%',
              maxWidth: '450px',
              mx: 'auto',
            }}
          >
            <AppButton variant="neutral" fullWidth onClick={this.handleRetry}>
              <Refresh />
              Try Again
            </AppButton>
            <AppButton variant="brand" fullWidth onClick={this.handleReload}>
              Back to Homepage
            </AppButton>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
